import { render, staticRenderFns } from "./Canchas.vue?vue&type=template&id=2a34b37a&scoped=true"
import script from "./Canchas.vue?vue&type=script&lang=js"
export * from "./Canchas.vue?vue&type=script&lang=js"
import style0 from "./Canchas.vue?vue&type=style&index=0&id=2a34b37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34b37a",
  null
  
)

export default component.exports